const obj = {
  title: "为什么选 FraudVision？".toUpperCase(),
  text1: {
    regular: "FraudVision 就是圈内对抗封群、删帖和外部压力的终极答案。".toUpperCase(),
    bold: "".toUpperCase(),
  },
  text2: {
    regular: "我们天天在全平台实时更新、维护群聊链接，这阵势，谁删得掉？".toUpperCase(),
    bold: "想都别想。".toUpperCase(),
  },
  text3: "FraudVision 也是圈子抵制烂项目、劣质货的最强屏障。".toUpperCase(),
  text4: "有没有发现，现在这些赚钱群都TM变成约炮聊草的垃圾堆了？".toUpperCase(),
  text5: "更别提那些刷量群、机器人论坛了，搞得大家都没法信任，真正老炮的面子都要丢光了。".toUpperCase(),
  text6: "更别提那些刷量群、机器人论坛了，搞得大家都没法信任，真正老炮的面子都要丢光了。".toUpperCase(),
  text7: "我们要做的是稳固圈子、扎深根基，认真搞钱。".toUpperCase(),
  we_are_the: "我们，就是".toUpperCase(),
  text8: "我们的使命只有一个：让圈子更强、更富。整个社区都将被牢牢绑定在共同的利益之下。".toUpperCase(),
  text9: "只要你信誉够硬、合作靠谱，我们随时欢迎你加入一起搞事。".toUpperCase(),
}

const formatted = obj
export default formatted
